import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Header from './components/Header';
import Aside from './components/Aside';
import Logo from './components/Logo';
import styles from './index.module.scss';

function BasicLayout(props) {
  const [collapsed, setCollapsed] = useState(false);
  const [compactLibrary, setCompactLibrary] = useState(false);
  const [compactExpanded, setCompactExpanded] = useState(false);
  const pathname = props.location.pathname;
  useEffect(() => {
    const media = window.matchMedia('(max-width: 640px)');
    const update = () => {
      setCompactLibrary(pathname === '/DocumentLibrary' && media.matches);
      setCompactExpanded(false);
    };
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, [pathname]);
  const menuCollapsed = compactLibrary ? !compactExpanded : collapsed;

  return (
    <div className={styles.layout}>
      <aside className={`${styles.aside} ${menuCollapsed ? styles.collapsed : ''}`}>
        <div className={styles.brand}>
          <Logo collapsed={menuCollapsed} />
        </div>
        <div className={styles.menuWrap}>
          <Aside />
        </div>
        <button
          type="button"
          className={styles.collapseBtn}
          onClick={() => compactLibrary ? setCompactExpanded((v) => !v) : setCollapsed((v) => !v)}
          title={menuCollapsed ? '展开菜单' : '收起菜单'}
        >
          {menuCollapsed ? '›' : '‹ 收起菜单'}
        </button>
      </aside>
      <div className={styles.right}>
        <Header />
        <main id="basic-layout-main" className={styles.main}>
          {props.children}
        </main>
      </div>
    </div>
  );
}

export default withRouter(BasicLayout);
